import { Duration, Style } from './types';
import { jumpToStartStyle } from './jumpToStartStyle';
import { animateToEndStyle } from './animateToEndStyle';
import { cleanUpAnimation } from './cleanUpAnimation';

/**
 * Animates `element` from `startStyle` to `endStyle` over the given `duration`
 */
export const animateElement = async (
  startStyle: Style,
  endStyle: Style,
  element: HTMLElement,
  duration: Duration,
) => {
  await jumpToStartStyle(startStyle, element);
  const completionType = await animateToEndStyle(endStyle, element, duration);
  cleanUpAnimation(element, completionType);
  return completionType;
};
